import {Card, CardContent, Link} from "@mui/material"
import {styled} from "@mui/material/styles"

export const TileCard = styled(Card)`
    width: 100%;
    height: auto;
    overflow: inherit;
`

export const TileCardContent = styled(CardContent)`
    padding: 0 0 1.575rem 0;
    position: relative;
    ${({theme}) =>
        theme.enablingCenteredContent &&
        `
        text-align: center;
  `}
`
export const ImageContainer = styled("div")`
    position: relative;
`

export const TileCardBrandNameWrapper = styled("span")`
    min-height: 1.125rem;
    vertical-align: top;
    margin-top: 0.094rem;
`
export const StyledTitleWrapper = styled("h2")`
    margin: 0;
`

export const StyledLink = styled(Link)`
    &:focus {
        outline: Highlight auto 1px !important;
    }
`
